import {
  Component,
  EventEmitter,
  Injector,
  Input,
  Output,
} from '@angular/core';

import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorConnector } from '../controlvalue-accessor.connector';

@Component({
  selector: 'app-dc-asset-display',
  templateUrl: './dc-asset-display.component.html',
  styleUrls: ['./dc-asset-display.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: DcAssetDisplayComponent,
      multi: true,
    },
  ],
})
export class DcAssetDisplayComponent extends ControlValueAccessorConnector {
  @Input() label: string;
  @Input() warning: string;
  @Input() labelId: string;
  @Input() multiple: boolean;
  @Input() searchable: boolean;
  @Input() closeOnSelect: boolean;
  @Input() checkbox: boolean;
  @Input() placeholder: string;
  @Input() darkMode?: boolean;
  @Input() loading: boolean;
  @Input() clearable = false;
  @Input() FreeText: boolean;
  @Input() showTicksIfValid: boolean; // off by default
  @Input() customErrorMessage: string;
  @Input() editButton: boolean;

  @Output() disableEvent = new EventEmitter<any>();
  @Output() selected = new EventEmitter<any>();
  @Output() editEvent = new EventEmitter<any>();

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {}

  onChange(e) {
    if (e !== undefined) {
      this.selected.emit(e.id);
    }
  }

  // Specific to underlying assets label (appears differently from dispalayValue)
  getLabel(label: string): string {
    const cleanLabel = label?.split(' | ') || [];
    const splitPipeLabel = cleanLabel?.length ? cleanLabel[1] : label;
    const splitBrLabel = splitPipeLabel?.split('<br>');
    return splitBrLabel?.length ? splitBrLabel[0] : label;
  }

  // Specific to underl
  getTitle(label: string): string {
    const title = label?.split('<br>') || [];
    return title?.length ? title.join(' | ') : label;
  }

  addTagFn(input) {
    return { displayValue: input, id: input };
  }

  edit() {
    this.editEvent.emit();
  }
}
